module.exports = __webpack_public_path__ + "img/img_size6_test.3aa85892.png";